import { render } from "./ViewTourPartSummary.vue?vue&type=template&id=2ec11578&scoped=true"
import script from "./ViewTourPartSummary.vue?vue&type=script&lang=ts"
export * from "./ViewTourPartSummary.vue?vue&type=script&lang=ts"

import "./ViewTourPartSummary.vue?vue&type=style&index=0&id=2ec11578&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2ec11578"

export default script